<template>
  <span>
    <template v-if="isLeftMonth">
      <pu-utc-date
        :date="dateRange.arrive"
        :options="{ month: 'short' }"
        class="search-summary-dates-left-month"
      />
    </template>
    <i18n-t keypath="{fromDate} - {toDate}" class="days">
      <template #fromDate>
        <pu-utc-date :date="dateRange.arrive" :options="{ day: 'numeric' }" />
      </template>
      <template #toDate>
        <pu-utc-date :date="dateRange.depart" :options="{ day: 'numeric' }" />
      </template>
    </i18n-t>
    <template v-if="!isLeftMonth">
      <pu-utc-date
        :date="dateRange.arrive"
        :options="{ month: 'short' }"
        class="search-summary-dates-right-month"
      />
    </template>
  </span>
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'
import { logger } from '../../../utility/logger'

@Component
class SearchSummaryBarDetailsCalendarSameMonth extends Vue {
  @Prop()
  dateRange: { arrive: string; depart: string }

  get isLeftMonth(): boolean {
    const date = new Intl.DateTimeFormat(this.$i18n.locale, {
      month: 'short',
      day: 'numeric',
    }).format(new Date(this.dateRange.arrive))
    return !date.match(/^\d/)
  }
}

export default toNative(SearchSummaryBarDetailsCalendarSameMonth)
</script>
<style scoped>
.search-summary-dates-left-month {
  padding-right: 0.125em;
}

.search-summary-dates-right-month {
  padding-left: 0.125em;
}
</style>
